import { ILayerProps } from '@/version-types';

export class RealEdit {
    constructor() {}

    /**
     * 发送历史记录步骤
     * @param type - 历史记录类型
     * @param data - 数据
     */
    send(type: string, data: any) {
        // 发送数据给其他用户，这里不需要实现，在 real-edit 中重载实现
    }

    /**
     * 发送差异数据给其他用户
     */
    sendDiff(data: any) {
        // 发送数据给其他用户，这里不需要实现，在 real-edit 中重载实现
    }

    sendLayer(layer: ILayerProps) {
        // 发送图层数据给其他用户，这里不需要实现，在 real-edit 中重载实现
    }

    /** 获取插入舞台的原始索引 */
    async insertStage(count: number): Promise<{
        originIndexs: number[];
        insertId: string;
    }> {
        // 返回空会在插入的时候自动生成
        // 多人协作场景会重写该方法，返回一个数组，数组的长度为插入的舞台数量
        return {
            originIndexs: [],
            insertId: '',
        };
    }

    /** 插入舞台结束 */
    insertStageEnd(insertId: string) {
        // 多人协作场景会重写该方法，在插入结束的时候调用
    }
}
